import React from 'react';
import Image from 'react-bootstrap/Image';
import * as styles from './styles/styles.module.scss';

class ProfileIcon extends React.Component {
  render() {
    return (
      <span>
        <Image className={styles.profile} data-testid="profileIcon" roundedCircle src={this.props.imagePath} />
      </span>
    );
  }
}

export default ProfileIcon;
